import * as React from 'react';

const Donation = props => (
  <svg
    width={100}
    height={86}
    viewBox="0 0 100 86"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon stroke="none" strokeWidth={1} fill="#E7EBF6" points="7 84 59 84 59 32 7 32" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M59.256,45 L7.744,45 C6.781,45 6,44.105 6,43 C6,41.895 6.781,41 7.744,41 L59.256,41 C60.219,41 61,41.895 61,43 C61,44.105 60.219,45 59.256,45 Z"
      opacity={0.2}
    />
    <polygon points="7.5 84.5 59.5 84.5 59.5 41.5 7.5 41.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EAFFF"
      d="M7.628,40.868 L59.876,40.868 L7.628,40.868 Z"
    />
    <polygon points="5.5 41.5 60.5 41.5 60.5 33.5 5.5 33.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      d="M39.301,52.967 C39.301,52.967 47.669,43.441 49.719,34.451 C51.769,25.461 48.851,24.109 43.955,23.187 C39.058,22.266 36.086,21.624 36.989,18.451 C37.892,15.278 43.955,12.353 43.955,12.353 C43.955,12.353 40.486,8.792 45.724,5.975 C50.961,3.157 54.255,2.146 58.677,2.005 C63.1,1.863 64.064,4.825 61.297,7.546 C58.53,10.266 55.423,19.727 63.298,24.947 C71.172,30.167 86.118,36.515 90.367,43.387 C94.616,50.259 96.794,53.159 96.974,65.102 C97.153,77.045 94.499,84.775 81.379,84.775 L58.677,84.775 C58.677,84.775 43.438,83.974 43.438,71.296"
    />
    <path d="M43.955,76.225 C43.955,76.225 46.737,84.5 60.594,84.5 L83.591,84.5 C83.591,84.5 97.006,84.707 97.006,69.523 C97.006,54.339 96.564,44.167 77.989,33.996 C59.415,23.824 59.415,22.35 59.415,15.274 C59.415,8.198 63.1,5.25 63.1,5.25 C63.1,5.25 61.184,0.827 53.961,2.301 C46.737,3.775 40.988,8.935 43.347,11.736 C45.705,14.537 56.909,19.552 56.024,32.523" />
    <path d="M42.809,12.71 C42.809,12.71 36.27,16.543 36.418,19.933 C36.565,23.324 48.8,20.818 50.275,27.304 C51.749,33.79 40.897,52.463 40.897,52.463" />
    <path d="M50.275,27.304 C50.275,27.304 51.386,22.196 61.297,21.58" />
    <path d="M2,84.5 L98,84.5" />
    <polygon stroke="none" strokeWidth={1} fill="#FFFFFF" points="24 83 72 83 72 51 24 51" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M70.75,64 L25.25,64 C24.559,64 24,63.328 24,62.499 C24,61.672 24.559,61 25.25,61 L70.75,61 C71.441,61 72,61.672 72,62.499 C72,63.328 71.441,64 70.75,64"
      opacity={0.2}
    />
    <polygon points="25.5 84.5 70.5 84.5 70.5 60.5 25.5 60.5" />
    <polygon points="23.5 60.5 73.5 60.5 73.5 52.5 23.5 52.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M54.298,67.679 C52.808,66.189 50.393,66.189 48.904,67.679 L48.435,68.148 L47.966,67.679 C46.476,66.189 44.061,66.189 42.572,67.679 C41.082,69.169 41.082,71.584 42.572,73.073 L43.041,73.542 L47.376,77.877 C47.961,78.462 48.909,78.462 49.494,77.877 L53.829,73.542 L54.298,73.073 C55.788,71.584 55.788,69.169 54.298,67.679"
    />
  </svg>
);

export default Donation;



// WEBPACK FOOTER //
// ./src/assets/images/icons/donation.js